if (!customElements.get('custom-size-calculator')) {
  class CustomSizeCalculator extends HTMLElement {
    connectedCallback() {
      this.sqFtPrice = parseFloat(this.dataset.sqFtPrice) || 0;
      this.sqFtPriceCents = parseInt(this.dataset.sqFtPriceCents, 10) || 0;

      this.selects = this.querySelectorAll('.custom-size-calculator__select');
      this.priceBox = this.querySelector('.custom-size-calculator__price');
      this.areaDisplay = this.querySelector('[data-calc-area]');
      this.totalDisplay = this.querySelector('[data-calc-total]');

      this.propLength = this.querySelector('[data-prop="length"]');
      this.propWidth = this.querySelector('[data-prop="width"]');
      this.propArea = this.querySelector('[data-prop="area"]');
      this.propAreaRaw = this.querySelector('[data-prop="area-raw"]');

      // Find the Add to Cart button in the parent form
      this.form = this.closest('form') || this.closest('product-form-component');
      this.addToCartBtn = this.form
        ? this.form.querySelector('[name="add"]')
        : null;

      // Disable Add to Cart until dimensions are selected
      if (this.addToCartBtn) {
        this.addToCartBtn.disabled = true;
      }

      this.selects.forEach(function (sel) {
        sel.addEventListener('change', this.calculate.bind(this));
      }.bind(this));
    }

    calculate() {
      var lengthFt = parseInt(this.querySelector('[data-dimension="length-ft"]').value, 10);
      var lengthIn = parseInt(this.querySelector('[data-dimension="length-in"]').value, 10) || 0;
      var widthFt = parseInt(this.querySelector('[data-dimension="width-ft"]').value, 10);
      var widthIn = parseInt(this.querySelector('[data-dimension="width-in"]').value, 10) || 0;

      // Require at least the feet values
      if (isNaN(lengthFt) || isNaN(widthFt)) {
        this.priceBox.style.display = 'none';
        if (this.addToCartBtn) this.addToCartBtn.disabled = true;
        this.clearProperties();
        return;
      }

      var lengthTotal = lengthFt + lengthIn / 12;
      var widthTotal = widthFt + widthIn / 12;
      var area = lengthTotal * widthTotal;

      // Round area to 2 decimal places
      area = Math.round(area * 100) / 100;

      if (area < 4) {
        this.priceBox.style.display = 'block';
        this.areaDisplay.textContent = area.toFixed(2);
        this.totalDisplay.textContent = 'Min 4 sq ft';
        this.totalDisplay.style.color = '#c00';
        if (this.addToCartBtn) this.addToCartBtn.disabled = true;
        this.clearProperties();
        return;
      }

      var totalPrice = area * this.sqFtPrice;
      totalPrice = Math.round(totalPrice * 100) / 100;

      // Update display
      this.priceBox.style.display = 'block';
      this.areaDisplay.textContent = area.toFixed(2);
      this.totalDisplay.textContent = '$' + totalPrice.toFixed(2);
      this.totalDisplay.style.color = '';

      // Update hidden properties
      this.propLength.value = lengthFt + ' ft ' + lengthIn + ' in';
      this.propWidth.value = widthFt + ' ft ' + widthIn + ' in';
      this.propArea.value = area.toFixed(2) + ' sq ft';
      this.propAreaRaw.value = area.toFixed(2);

      // Enable Add to Cart
      if (this.addToCartBtn) this.addToCartBtn.disabled = false;
    }

    clearProperties() {
      this.propLength.value = '';
      this.propWidth.value = '';
      this.propArea.value = '';
      this.propAreaRaw.value = '';
    }
  }

  customElements.define('custom-size-calculator', CustomSizeCalculator);
}
